// Framework and third-party non-ui
import React, { useState, useContext, useEffect } from 'react';
import { MapContext } from 'contexts/MapContext';

// Third-party components (buttons, icons, etc.)
import { makeStyles } from '@material-ui/core/styles';

// App components
import OptionAttribute from 'components/Attribute/OptionAttribute';
import Any from '../Any';

import { activityTypeCodes, difficultyCodes, primaryTypeCodes, suitabilityTypeCodes } from '../config';
import { SearchContext } from 'contexts/SearchContext';

const OptionGroup = ({ optionType, attributes }) => {
  const [selected, setSelected] = useState(false);
  const { advancedOptions, setAdvancedOptions, featureList, setFilteredFeatureList } = useContext(MapContext);
  const { state, setState } = useContext(SearchContext);

  const useStyles = makeStyles((theme) => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '400px',
    },
    groupTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '10px 10px',
    },
    options: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: '10px 10px',
      gap: '10px',
    },
    optionTitle: {
      fontFamily: 'Open Sans',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '.25px',
      color: '#222222',
    },
  }));
  const classes = useStyles();

  const selectedHandler = () => {
    //force rerender irregardless of whether selected is null or false
    //so that all OptionAttribute child component clicked states are set to falsey value
    if (selected === null) {
      setSelected(false);
    } else {
      setSelected(null);
    }

    setAdvancedOptions({ ...advancedOptions, [optionType]: {} });
  };

  const setOptionAttribute = (attribute, value) => {
    //If an option was selected clear search term
    value && setState({ ...state, searchTerm: '' });
    setAdvancedOptions({
      ...advancedOptions,
      [optionType]: { ...advancedOptions[optionType], [attribute]: value },
    });
  };

  return (
    <div className={classes.container}>
      <div className={classes.groupTitle}>
        <div className={classes.optionTitle}>{optionType}</div>
        <Any selectedHandler={selectedHandler} selected={selected} />
      </div>
      <div className={classes.options}>
        {attributes.map((attribute) => (
          <OptionAttribute
            attribute={attribute}
            selected={selected}
            setOptionAttribute={setOptionAttribute}
            options={advancedOptions}
            optionType={optionType}
          />
        ))}
      </div>
    </div>
  );
};

export default OptionGroup;
